<a
  [class]="itemClasses()"
  [routerLink]="href()"
  [attr.aria-disabled]="disabled() ? 'true' : null"
  [attr.aria-current]="active() ? 'page' : null"
  (click)="onClick($event)"
>
  <span class="ps-nav-item-content">
    <div class="ps-nav-item-icon-wrapper">
      <ps-icon [name]="icon()"></ps-icon>
    </div>

    @if (!isCompact()) {
      <span class="ps-nav-item-label"><ng-content /></span>
    }
  </span>

  @if (hasBadge() && !isCompact()) {
    <div class="ps-nav-item-badge-wrapper">
      <ps-badge [variant]="active() ? 'primary' : 'light'">
        {{ badgeLabel() }}
      </ps-badge>
    </div>
  }
</a>
